












































































































































































































import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import AddressDTO from "@/dto/AddressDTO";
import {STATE_LIST} from "@/constants/ProfileConstants";
import AutoComplete from "@/components/common/AutoComplete.vue";
import AutoCompleteDTO from "@/components/common/AutoCompleteDTO";
import PortalInput from "@/components/common/PortalInput.vue";
import CompanySearch from "@/components/common/CompanySearch.vue";
import PersonSearch from "@/components/common/PersonSearch.vue";
import PortalDateTime from "@/components/common/PortalDateTime.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import {v4 as uuidv4} from "uuid";
import {PropType} from "vue";

export type Mode = "COLLAPSE" | "PLAIN"

export type FieldId = "address1" | "address2" | "foreignAddress" | "city" | "state" | "zipCode" | "country"

@Component({
	computed: {
		SelectOption() {
			return SelectOption
		},
		states(): Array<string> {
			return STATE_LIST;
		},
		AutoCompleteDTO() {
			return AutoCompleteDTO
		}
	},
	components: {
		PortalCheckbox,
		BTPortalCollapse, SublimeSearch, PortalSelect, PortalDateTime, PersonSearch, CompanySearch, PortalInput, AutoComplete}
})
export default class PortalAddress extends Vue {
	private addressIsOpenMirror = false

	@Prop({default: "COLLAPSE"})
	private mode!: Mode

	@Prop({default: false})
	private onlyUS!: boolean

	@Prop({default: false})
	private addressIsOpen!: boolean;

	@Prop({default: null})
	private validatePattern!: Record<FieldId, string | Record<string, any>> | null

	@VModel({type: AddressDTO, default: () => new AddressDTO()})
	private address!: AddressDTO

	@Prop({default: function () {return uuidv4()}})
	private id!: string;

	get verified(): boolean {
		return this.address.verified
	}

	@Prop()
	private label!: string | null

	@Prop({default: false})
	private isOpen!: boolean

	private isOpenMirror!: boolean;

	private tabIndex = 0;

	private resolveValidateRule(key: FieldId): string | Record<string, any> {
		if (this.validatePattern == null) return "";
		if (this.validatePattern[key]) return this.validatePattern[key];
		return "";
	}

	public created(): void {
		this.isOpenMirror = this.isOpen
		this.addressIsOpenMirror = this.addressIsOpen;
	}

	private applyNoResidential() {
		this.address.isResidential = false;
		this.$emit("input", this.address)
	}

	private applyResidential() {
		this.address.isResidential = true;
		this.$emit("input", this.address)
	}

  private filterForeignZIPCode() {
    this.address.zipCode = this.address.zipCode.replace(/[^\d./-]/g, '');
  }

  private requireIfResidental(rule: string): string {
	  return !this.address.isResidential ? this.replaceRequired(rule) : rule;
  }

	private requireIfNotResidental(rule: string): string {
		return this.address.isResidential ? this.replaceRequired(rule) : rule;
	}

	replaceRequired(rule: string): string {
		rule = rule.replaceAll("required", "")
		return rule.startsWith("|") ? rule.slice(1) : rule;
	}
}
